import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function HomeLineIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            className='icon'
            {...rest} >
            <path d="M6 21H9.86667H14.1333H18C19.1046 21 20 20.1046 20 19V10.8C20 10.2174 19.746 9.66382 19.3043 9.28388L13.3043 4.12211C12.5544 3.47698 11.4456 3.47698 10.6957 4.12211L4.69567 9.28388C4.25402 9.66382 4 10.2174 4 10.8V19C4 20.1046 4.89543 21 6 21Z" stroke={color} strokeWidth="2"/>
            <path d="M10 13H14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default HomeLineIcon;
